"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_PLUGINS = exports.SpotPlugin = exports.SellwildPlugin = exports.OpenSlotPlugin = exports.NewslettersPlugin = exports.KeystonePlugin = exports.FallbackVideoPlugin = exports.BytesPlugin = exports.AdPlugin = void 0;
var ad_1 = require("./ad");
Object.defineProperty(exports, "AdPlugin", { enumerable: true, get: function () { return ad_1.AdPlugin; } });
var bytes_1 = require("./bytes");
Object.defineProperty(exports, "BytesPlugin", { enumerable: true, get: function () { return bytes_1.BytesPlugin; } });
var fallbackVideo_1 = require("./fallbackVideo");
Object.defineProperty(exports, "FallbackVideoPlugin", { enumerable: true, get: function () { return fallbackVideo_1.FallbackVideoPlugin; } });
var keystone_1 = require("./keystone");
Object.defineProperty(exports, "KeystonePlugin", { enumerable: true, get: function () { return keystone_1.KeystonePlugin; } });
var newsletters_1 = require("./newsletters");
Object.defineProperty(exports, "NewslettersPlugin", { enumerable: true, get: function () { return newsletters_1.NewslettersPlugin; } });
var openSlot_1 = require("./openSlot");
Object.defineProperty(exports, "OpenSlotPlugin", { enumerable: true, get: function () { return openSlot_1.OpenSlotPlugin; } });
var sellwild_1 = require("./sellwild");
Object.defineProperty(exports, "SellwildPlugin", { enumerable: true, get: function () { return sellwild_1.SellwildPlugin; } });
var spot_1 = require("./spot");
Object.defineProperty(exports, "SpotPlugin", { enumerable: true, get: function () { return spot_1.SpotPlugin; } });
exports.SUPPORTED_PLUGINS = [
    'Ad',
    'Bytes',
    'FallbackVideo',
    'InContentAd',
    'Keystone',
    'Newsletters',
    'OpenSlot',
    'Sellwild',
    'Spot',
];
//# sourceMappingURL=index.js.map